import { render, staticRenderFns } from "./riskInsight.vue?vue&type=template&id=8ab041aa&scoped=true"
import script from "./riskInsight.vue?vue&type=script&lang=js"
export * from "./riskInsight.vue?vue&type=script&lang=js"
import style0 from "./riskInsight.vue?vue&type=style&index=0&id=8ab041aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab041aa",
  null
  
)

export default component.exports